import WebviewPage from './WebviewPage'

export default WebviewPage
